// removed by extract-text-webpack-plugin
module.exports = {"btn-secondary":"_1yZm"};


//////////////////
// WEBPACK FOOTER
// ./checkout/components/transparent-button/style.css
// module id = +y/E
// module chunks = 4